export const SignupFrameMaxWidth = 520;
export const SignupFrameMaxHeight = 700;
export const ScheduleFrameMaxWidth = 1350;
export const ScheduleFrameMaxHeight = 800;
export const ScheduleFrameMaxHeightMobile = 700;
